import { KibButtonNew } from '@chewy/kib-controls-react';
import Link from 'next/link';

import { useMealPlanFormContext } from '../MealPlanForm/MealPlanFormProvider';

export const FormAnchorLink = ({
  onClick,
  text,
  className,
  emphasis = 'primary',
}: {
  onClick: () => void;
  text: string;
  className?: string;
  emphasis?: 'primary' | 'secondary';
}) => {
  const { openWithAnchorTag } = useMealPlanFormContext();

  return (
    <>
      {openWithAnchorTag ? (
        <KibButtonNew
          className={className}
          emphasis={emphasis}
          theme="action"
          onClick={onClick}
          href="/get-real/signup"
          data-testid="go-to-form-button"
        >
          {text}
        </KibButtonNew>
      ) : (
        <Link href="/get-real/signup" passHref legacyBehavior>
          <KibButtonNew
            className={className}
            emphasis={emphasis}
            theme="action"
            onClick={onClick}
            data-testid="go-to-form-button"
          >
            {text}
          </KibButtonNew>
        </Link>
      )}
    </>
  );
};
